// extracted by mini-css-extract-plugin
export default {"columnCheckbox":"DishesTableTHead_columnCheckbox__LvJPz","checkbox":"DishesTableTHead_checkbox__Lhx1s","placeHolderShimmer":"DishesTableTHead_placeHolderShimmer__P1OnB"};